import { Container } from '@mui/material';
import type { PageProps } from 'gatsby';
import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import { defineMessages, useIntl } from 'react-intl';

import { DrilldownHeader } from '@components/DrilldownHeader';
import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';

import AppLayout from '@layouts/AppLayout';

import Drilldown from '@views/Records/Insurance/Drilldown';

const messages = defineMessages({
  insurance: {
    id: 'insuranceDrilldown.title',
    defaultMessage: 'Insurance',
  },
});

function InsurancePage({ params }: PageProps) {
  return <Drilldown {...params} />;
}

export default withErrorBoundary(InsurancePage, {
  FallbackComponent: (props) => {
    const { formatMessage } = useIntl();
    const title = formatMessage(messages.insurance);
    return (
      <AppLayout friendlyName={title}>
        <DrilldownHeader backRoute="/" title={title} />
        <Container maxWidth="lg">
          <ErrorBoundaryFallback {...props} />
        </Container>
      </AppLayout>
    );
  },
});
